import { Link } from "react-router-dom";

export function AdminAnalyticsNav({ active = "buyers" }) {
  const items = [
    { key: "marketplace", label: "Marketplace", href: "/admin/analytics/marketplace" },
    { key: "buyers", label: "Compradores", href: "/admin/analytics/buyers" },
    { key: "funnels", label: "Embudos", href: "/admin/analytics/funnels" },
    { key: "search", label: "Búsqueda", href: "/admin/analytics/search" },
    { key: "quiz", label: "Quiz", href: "/admin/analytics/quiz" },
    { key: "leads", label: "Leads", href: "/admin/analytics/leads" },
    { key: "dealers", label: "Concesionarios", href: "/admin/analytics/dealers" },
    { key: "attribution", label: "Atribución", href: "/admin/analytics/attribution" },
  ];

  return (
    <nav className="admin-console__nav-tabs admin-analytics-nav">
      {items.map((item) => (
        <Link key={item.key} to={item.href} className={active === item.key ? "is-active" : undefined}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

export function AnalyticsRangeSelect({ range, onChange, options }) {
  return (
    <label className="dashboard-range-select">
      Periodo
      <select value={range} onChange={(e) => onChange(e.target.value)}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function AnalyticsSummaryGrid({ items }) {
  return (
    <div className="dashboard-summary-grid">
      {items.map((item) => (
        <div key={item.label} className="dashboard-summary-card">
          <span className="dashboard-summary-label">{item.label}</span>
          <strong className="dashboard-summary-value">{item.value ?? "—"}</strong>
          {item.hint ? <small className="muted">{item.hint}</small> : null}
        </div>
      ))}
    </div>
  );
}

export function AnalyticsBreakdownTable({ title, rows, keyLabel = "Clave" }) {
  if (!rows?.length) {
    return (
      <section className="dealer-state-box">
        <h3>{title}</h3>
        <p className="muted">Sin datos en este periodo.</p>
      </section>
    );
  }
  return (
    <section className="dealer-state-box">
      <h3>{title}</h3>
      <table className="dealer-inventory-table">
        <thead>
          <tr>
            <th>{keyLabel}</th>
            <th>Conteo</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td>{row.key}</td>
              <td>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export function FunnelStepsTable({ steps }) {
  if (!steps?.length) return null;
  return (
    <section className="dealer-state-box">
      <h3>Pasos del embudo</h3>
      <table className="dealer-inventory-table">
        <thead>
          <tr>
            <th>Paso</th>
            <th>Conteo</th>
            <th>Conversión</th>
            <th>Abandono</th>
          </tr>
        </thead>
        <tbody>
          {steps.map((step) => (
            <tr key={step.id}>
              <td>{step.label}</td>
              <td>{step.count}</td>
              <td>{step.conversionRate}%</td>
              <td>{step.dropOffRate}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
